import { Button } from '@/components/ui/button';
import { useAuth } from '@/components/auth/AuthProvider';
import TenantAuditsSubmissions from './TenantAuditsSubmissions';
import { LogOut } from 'lucide-react';
import { useLeadInsertNotifications } from '@/hooks/useLeadInsertNotifications';
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export default function TenantAuditsAdmin() {
  const { signOut } = useAuth();
  useLeadInsertNotifications({ tenantId: undefined });

  // Apply Audits colors to CSS variables for this minimal admin
  useEffect(() => {
    const apply = async () => {
      try {
        const { data } = await supabase.from('tenants').select('color_scheme_json').eq('subdomain', 'audits').maybeSingle();
        const cfg = data?.color_scheme_json;
        const colorScheme = typeof cfg === 'string' ? JSON.parse(cfg) : cfg;
        if (!colorScheme) return;
        const root = document.documentElement as HTMLElement;
        if (colorScheme.primary) root.style.setProperty('--tenant-primary', colorScheme.primary);
        if (colorScheme.secondary) root.style.setProperty('--tenant-secondary', colorScheme.secondary);
        if (colorScheme.accent) root.style.setProperty('--tenant-accent', colorScheme.accent);
        if (colorScheme.background) root.style.setProperty('--tenant-background', colorScheme.background);
        if (colorScheme.text) root.style.setProperty('--tenant-text', colorScheme.text);
      } catch {}
    };
    apply();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Top bar */}
      <div className="tenant-nav sticky top-0 z-40 flex h-14 items-center justify-between px-4 border-b text-white">
        <div className="font-semibold">Tenant Dashboard - Audits</div>
        <Button variant="ghost" size="sm" onClick={signOut} className="text-white">
          <LogOut className="h-4 w-4 mr-1" /> Sign out
        </Button>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto p-4 sm:p-6">
        <TenantAuditsSubmissions />
      </div>
    </div>
  );
}

